<template>
  <vs-popup
    class="guide-popup"
    title="Kılavuz"
    :active.sync="isActive"
  >
    <div v-if="loading" class="text-center py-6">
      <span>Yükleniyor...</span>
    </div>

    <div v-else>
      <vs-collapse v-if="sections.length" accordion>
        <vs-collapse-item
          v-for="(section, index) in sections"
          :key="section.url || index"
          :open="index === 0"
        >
          <div slot="header">{{ section.title }}</div>

          <div class="guide-section-body">
            <div v-if="section.pdfLoading" class="text-center py-4">
              <span>PDF yükleniyor...</span>
            </div>
            <iframe
              v-else-if="section.blobUrl"
              :src="section.blobUrl"
              class="guide-pdf-frame"
              frameborder="0"
            ></iframe>
            <div v-else class="text-center py-4">
              <span>PDF görüntülenemedi. </span>
              <a v-if="section.url" :href="section.url" target="_blank" rel="noopener">
                Yeni sekmede aç
              </a>
            </div>
          </div>
        </vs-collapse-item>
      </vs-collapse>

      <div v-else class="text-center py-6">
        <span>Bu sayfa için henüz bir kılavuz bulunmuyor.</span>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import axios from "axios";

const PDF_VIEWER_PARAMS = "#toolbar=0&navpanes=0";

export default {
  name: "guide-modal",
  props: {
    active: { type: Boolean, default: false }
  },
  data() {
    return {
      loading: false,
      sections: [] // [{ title, url, order, blobUrl, pdfLoading }]
    };
  },
  computed: {
    isActive: {
      get() {
        return this.active;
      },
      set(val) {
        this.$emit("update:active", val);
      }
    },
    pageKey() {
      return this.$route.name;
    }
  },
  watch: {
    isActive(val) {
      if (val) this.loadGuide();
    }
  },
  methods: {
    loadGuide() {
      this.revokeBlobUrls();
      this.sections = [];
      this.loading = true;

      const soap = require("soap");
      const args = { gorunecegiSayfa: this.pageKey };

      soap.createClient(this.$store.state.loginServiceUrl, (err, client) => {
        if (err || !client) {
          this.loading = false;
          return;
        }

        client.kilavuzDosyaUrl(args, (err, result) => {
          this.loading = false;
          if (err || !result) return;
          this.sections = this.parseSections(result);
          this.sections.forEach(section => this.loadPdf(section));
        });
      });
    },
    parseSections(result) {
      try {
        let raw = result;
        if (result && result.return != null) {
          raw = result.return.$value != null ? result.return.$value : result.return;
        }

        raw = (raw || "").toString().trim();
        if (!raw || raw === "-1") return [];

        let arr = JSON.parse(raw);
        if (!Array.isArray(arr)) arr = [arr];

        return arr
          .filter(o => o && o.pdfUrl)
          .map(o => ({
            title: o.kilavuzBasligi || "Kılavuz",
            url: o.pdfUrl,
            order: typeof o.siraNo === "number" ? o.siraNo : 0,
            blobUrl: "",
            pdfLoading: false
          }))
          .sort((a, b) => a.order - b.order);
      } catch (e) {
        return [];
      }
    },
    loadPdf(section) {
      if (!section.url) return;
      section.pdfLoading = true;
      axios
        .get(section.url, { responseType: "blob" })
        .then(res => {
          const blob = new Blob([res.data], { type: "application/pdf" });
          section.blobUrl = URL.createObjectURL(blob) + PDF_VIEWER_PARAMS;
        })
        .catch(() => {
          section.blobUrl = "";
        })
        .finally(() => {
          section.pdfLoading = false;
        });
    },
    revokeBlobUrls() {
      this.sections.forEach(section => {
        if (section.blobUrl) {
          URL.revokeObjectURL(section.blobUrl.split("#")[0]);
          section.blobUrl = "";
        }
      });
    }
  },
  beforeDestroy() {
    this.revokeBlobUrls();
  }
};
</script>

<style lang="scss">
$guide-primary: #7a4ce6;

.guide-popup .vs-popup {
  width: 80%;
  max-width: 1100px;
}

.guide-popup {
  .vs-collapse {
    padding: 0;
  }

  .vs-collapse-item {
    border: 1px solid #e4e1ef;
    border-radius: 10px;
    margin-bottom: 12px;
    overflow: hidden;
    background: #fff;
  }

  .vs-collapse-item--header {
    padding: 14px 18px;
    font-weight: 600;
    font-size: 0.98rem;
    color: #2c2c3a;
    background: #efeafc;
    cursor: pointer;
    transition: background 0.2s ease, color 0.2s ease;
  }

  .vs-collapse-item.open-item {
    & > .vs-collapse-item--header {
      background: $guide-primary;
      color: #fff;
    }
  }

  .con-content--item {
    padding: 16px 18px;
  }

  .guide-section-body {
    min-height: 70vh;
    display: flex;
    flex-direction: column;

    .text-center {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .guide-pdf-frame {
    flex: 1;
    width: 100%;
    height: 70vh;
    border: 1px solid #e4e1ef;
    border-radius: 8px;
    background: #fff;
  }
}
</style>
